import { get, includes, filter, find, head, orderBy } from 'lodash';

export const isLoading = (state, teamId) => {
  const loading = get(state, 'teams.leagueTable.currentlyLoading');
  return includes(loading, teamId);
};

export const hasLoaded = (state, teamId) => {
  const loaded = get(state, 'teams.leagueTable.hasLoaded');
  return includes(loaded, teamId);
};

export const getTables = (state, teamId) => get(state, `teams.leagueTable.tables[${teamId}]`, []);

export const getTablesBySeason = (state, teamId, seasonId) =>
  filter(getTables(state, teamId), { season_id: seasonId });

export const getSeasons = (state, teamId) => {
  const seasons = get(state, `teams.leagueTable.seasons[${teamId}]`, []);
  return orderBy(seasons, ['end'], ['desc']);
};

export const getDefaultSeasonId = (state, teamId) => {
  const season = head(getSeasons(state, teamId));
  return season && season.id;
};

export const getDefaultTable = (state, teamId, seasonId) =>
  find(getTables(state, teamId), { season_id: seasonId });

export const getTable = (state, teamId, tableId) => find(getTables(state, teamId), { id: tableId });

export const getLoadingError = (state, teamId) =>
  find(get(state, 'teams.leagueTable.loadingError'), { teamId });
